import { Component, inject, computed, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService } from '../../../../../service/user-login.service';
import { LP_NAVIGATION_TABS } from '../../../../../helpers';

@Component({
  selector: 'app-loss-prevention-admin-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  standalone: false,
})
export class LossPreventionAdminNavigationComponent implements OnInit {
  private router = inject(Router);
  private userService = inject(UserLoginService);

  public activeNavItem: string = '';
  public navItems = LP_NAVIGATION_TABS;

  public visibleTabs = computed(() => {
    const roles = this.userService.currentProfileRoleList();
    return this.navItems.filter((f) => f.allowed.some((r) => roles.includes(r)));
  });

  ngOnInit(): void {
    this.userService.currentProfileLoaded$.subscribe(() => {
      const roles = this.userService.currentProfileRoleList();
      if (!roles.includes('admin') && !roles.includes('validator')) {
        this.router.navigate(['/lp']);
      }
    });
  }
}
